var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon0, _path9, _path0, _path1, _path10, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polyline, _polygon16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParamasaur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "145.4mm",
    height: "107.4mm",
    viewBox: "0 0 412.3 304.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5e76c;}.cls-2{fill:#a7cf38;}.cls-3{fill:#86ab3f;}.cls-4{fill:#4d612c;}.cls-5{fill:#86a63e;}.cls-6{fill:#fff;}.cls-7{fill:#231f20;}.cls-8{fill:#f1f2f2;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.8 43.2 127.4 7.7 146.5 52.5 146.5 68.1 99.8 43.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "203.4 221.5 250.1 229.2 207.7 250.4 203.4 221.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "149.7 52.5 178.7 0 192.5 51 149.7 52.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "368.4 274.1 397.5 245.1 397.5 290.9 368.4 274.1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "316 263.1 332.8 227.2 352.8 274.1 316 263.1"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "253.3 266.5 278.3 226.2 291.4 260.8 253.3 266.5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210.2 168.7 253.3 184.9 200.2 203.8 205.3 158 210.2 168.7"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "200.7 65 252.8 71.1 216.8 100.5 200.7 65"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "220.5 149.9 264.9 130 219 112.8 220.5 149.9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.8,269.1s-16.5-43.2-12.6-71.7c0,0,23.9-27.9,16.3-87.6-1.4-11.2,1.2-21.5-2.6-32.9s-14-23.2-25.9-29a49.7,49.7,0,0,0-19.3-5c-8.2-.3-15.6,5-23.5,6.6a72.6,72.6,0,0,1-26.3.5c-10.7-1.9-20.9-9.3-31.6-9.9C75.1,39.3,62.1,52,53.1,64L15.4,146.6s-16.8,9-13.4,40.8c0,0,5.8,32.6,18,38.5,0,0,14.7,39.3,73.3,16.7l32.2-11.3L144.9,251v46.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20,226s-22.6-17.9,12.7-9.9a81.7,81.7,0,0,1,11.2,4.8c7.5,3.7,56.9-14.1,77.8-30l19.7-12.2s5-19.4,10.8-19.7c0,0,4.9,16-7.3,24.3L84.4,214,66.6,226s-25.3.3-32.6-3.4C34,222.6,21.7,228.9,20,226Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.4,224.5s42.4.2,55.7-29.3l-1.1-5.5s-51.6,28.1-55.5,29.9S76.4,224.5,76.4,224.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.5,189.7s-7.2-21.6-4.6-32.4c0,0,4.3-.7,6.4,5.6,0,0,7.7,14.8,7.1,17.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.4,188s27-25.1,37-25.3c0,0,12.5,2.4-18.5,30.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.6,130.1s-7-11.1-43.7-3.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.9,108.7s-7-11.1-43.7-3.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.6,270.4s129.5-43.3,198.7,31.4v2.7h-269l1.6-7.4Z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "125.5 231.3 166.7 214.5 205.6 304.5 143.3 304.5 144.9 251 125.5 231.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.4,78.6C45.5,76.4,22.7,74.2,0,71.2c0,0-.3,14,5.4,14.5-1.3-.1,1.6,17.9,1.9,19a33,33,0,0,0,30.9,22.9c16.3.4,26.2-12.1,30.2-26.8,2-7.6,5.6-9.5,15.7-7.8s9.3,5.8,10.4,13.9c.6,5.3,2.7,10.1,5.3,14.8,5.6,10,15.3,17.2,27.1,17.8,17.4.9,31.4-3.1,38.7-20.3l5.1-13.7c1-2.6,7.1-2.9,8.1-7.6,1.7-8.7-15.6-9-21.9-9.8C127.5,84.1,97.9,81.4,68.4,78.6Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.1,78l60.3,7.3S61.7,128,33.3,123.5C33.3,123.5,5.7,119.7,8.1,78Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.3,88,167,95.5c3.5.5-7.5,25.2-9,27.1-7.7,10.5-24.3,14-36.3,10.5C102.2,127.4,99.1,105.8,99.3,88Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.6,92.5l48.8,6.1A10.3,10.3,0,0,1,229,105c.7,1.6,1.8,5.5.8,7.1a2.7,2.7,0,0,1-.8.7c-2.9,1.9-6.7.5-9-1.8s-1.3-2.3-.9-3.9.6-2.6-1.1-3.2-6.8-.1-10-.2l-36.4,1.4Z"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "131 189.7 138.2 201.9 141.6 185 131 189.7"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "125.2 192.9 125.5 209.7 114.4 198.7 125.2 192.9"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "111.4 199.5 113.5 213.8 99.2 205.5 111.4 199.5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "99.2 205.5 99.3 218.6 88.3 212.1 99.2 205.5"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "84.4 214 84.4 225.7 75.5 219.6 84.4 214"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "67.8 221.2 64.8 233 57.2 223.7 67.8 221.2"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "53.3 223.5 48.5 234 43.9 222.9 53.3 223.5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "27.4 219.9 39.1 221.9 33.8 231.2"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "23.4 219.9 18.6 231.2 13.3 218.9 23.4 219.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParamasaur);
export default __webpack_public_path__ + "static/media/paramasaur.00332d4adff15ce4fee314461c1e45c4.svg";
export { ForwardRef as ReactComponent };